import { Vue, Watch, Prop, Component } from 'vue-property-decorator';
import { isNumber, isFinite, merge, cloneDeep } from 'lodash';
import type { ElForm } from 'element-ui/types/form';
import style from './style.vue';
import DialogFactory from '@/views/components/picker/dialogFactory';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import IPSDialog from '@/views/components/picker/dialog';

enum SplitType {
  AFTER_PAY = 1,
  AFTER_SENT,
  AFTER_RECEIVE,
}

const SplitTypeList = [
  { label: '支付后', value: SplitType.AFTER_PAY },
  { label: '发货后', value: SplitType.AFTER_SENT },
  { label: '收货后', value: SplitType.AFTER_RECEIVE },
];

@DialogFactory
@Component({
  mixins: [style],
})
export default class SiteSplitConfig extends IPSDialog {
  siteCode: string;

  $refs: {
    form: ElForm;
  };

  title = '网点配置';

  width = '540px';

  confirmloading = false;

  isOpenSplit;

  formData: SiteConfig = {
    isClose: false,
    isSplitMoney: false,
    list: [
      {
        gssmId: 0,
        recipientNum: '',
        recipientName: '',
        splitPercent: 0,
        splitType: 1,
        splitTime: 0,
        remark: '',
      },
    ],
    isOpenCstPolicy: 0,
    isOpenGuiderPolicy: 0,
    isOpenSalespersonPolicy: 0,
    isAutomaticProfitOut: 1,
    siteCode: '',
    cstPolicyName: '',
    guiderPolicyName: '',
    salespersonPolicyName: '',
  };

  margin = '';

  mounted() {
    this.getInfo();
  }

  beforeConfirm(resp, cb) {
    this.$refs.form.validate((result) => {
      if (result) {
        const postParams = Object.assign(
          {
            isClose: 1 - Number(this.formData.isClose),
            isSplitMoney: Number(this.formData.isSplitMoney),
            siteCode: this.siteCode,
            isOpenCstPolicy: Number(this.formData.isOpenCstPolicy),
            isOpenGuiderPolicy: Number(this.formData.isOpenGuiderPolicy),
            isOpenSalespersonPolicy: Number(this.formData.isOpenSalespersonPolicy),
            isAutomaticProfitOut: Number(this.formData.isAutomaticProfitOut),
          },
          {
            list: this.formData.list.map((v) => {
              return Object.assign({}, v, { splitPercent: v.splitPercent * 100 });
            }),
          },
        );
        IPSService.splitConfigSave({ postParams })
          .then((response) => {
            this.$emit('result', true);
            cb(result);
          })
          .catch((error) => {
            this.confirmloading = false;
          });
      } else {
        this.confirmloading = false;
        this.$emit('result', false);
        cb(result);
      }
    });
  }

  getInfo() {
    IPSService.splitConfigInfo({
      postParams: {
        siteCode: this.siteCode,
      },
    }).then((response: SiteConfig) => {
      response.isClose = !response.isClose;
      response.isSplitMoney = !!response.isSplitMoney;
      if (!response.list || !response.list.length) {
        response.list.push({
          gssmId: 0,
          recipientNum: '',
          recipientName: '',
          splitPercent: 0,
          splitType: 1,
          splitTime: 0,
          remark: '',
        });
      } else {
        response.list = response.list.map((v) => {
          v.splitPercent = v.splitPercent / 100;
          return v;
        });
      }
      this.formData = merge(this.formData, response);
      this.formData.isOpenCstPolicy = !!this.formData.isOpenCstPolicy;
      this.formData.isOpenGuiderPolicy = !!this.formData.isOpenGuiderPolicy;
      this.formData.isOpenSalespersonPolicy = !!this.formData.isOpenSalespersonPolicy;
      // this.formData.isAutomaticProfitOut = Number(this.formData.isAutomaticProfitOut);
    });
  }

  onBlur(val, e) {
    e && e.target.value && e.target.value.trim() ? (val.splitTime = e.target.value) : (val.splitTime = '0');
  }

  v_recipientNo(rule, value, callback) {
    if (value && value.trim() && isNumber(Number(value)) && isFinite(Number(value))) {
      this.margin = '';
      callback();
    } else {
      this.margin = '16px !important';
      callback(new Error('请输入商户号,由数字组成'));
    }
  }

  renderContent(h) {
    return (
      <div class="site-config">
        <el-form props={{ model: this.formData }} label-position="top" ref="form">
          <el-form-item>
            <div class="blockTitle">销售许可配置</div>
            <el-switch v-model={this.formData.isClose} active-text="允许销售"></el-switch>
            <div class="tip">
              <span class="redText">*&nbsp;</span>设置为禁止销售后，该网点将仅展示商品，但销售功能将被关闭
            </div>
          </el-form-item>
          {!!this.isOpenSplit && (
            <el-form-item>
              <div class="blockTitle">分账配置</div>
              <el-switch v-model={this.formData.isSplitMoney} active-text="开启分账"></el-switch>
            </el-form-item>
          )}
          {(this.formData.isSplitMoney && !!this.isOpenSplit ? this.formData.list : []).map((v, i) => {
            return [
              <el-form-item key={`recipientName${i}`} label="分账接收方名称" prop={`list[${i}].recipientName`} show-message={false} rules={{ required: true, trigger: ['blur', 'change'] }}>
                <el-input v-model={v.recipientName}></el-input>
              </el-form-item>,
              // 何波说商户号限制仅输入数字
              <el-form-item
                key={`recipientNum${i}`}
                label="分账接收方微信商户号"
                prop={`list[${i}].recipientNum`}
                show-message={!(v.recipientNum && v.recipientNum.trim() && isNumber(Number(v.recipientNum)) && isFinite(Number(v.recipientNum)))}
                style={`margin-bottom: ${this.margin}`}
                rules={{ required: true, validator: this.v_recipientNo, trigger: ['blur', 'change'] }}>
                <el-input v-model={v.recipientNum} class="width-100"></el-input>
              </el-form-item>,
              <div class="split">
                <el-form-item key={`splitPercent${i}`} label="分账比例" class="split-rate" prop={`list[${i}].splitPercent`} show-message={false} rules={{ required: true, trigger: ['blur', 'change'] }}>
                  <el-input-number v-model={v.splitPercent} precision={2} controls={false} style="width:100px" max={99.99} min={0.01}></el-input-number>
                  &nbsp;&nbsp;%
                </el-form-item>
                <el-form-item key={`splitType${i}`} label="默认分账时间" class="split-type" prop={`list[${i}].splitType`} show-message={false} rules={{ required: true, trigger: ['blur', 'change'] }}>
                  <el-select v-model={v.splitType} class="wid-70">
                    {SplitTypeList.map((s) => {
                      return <el-option label={s.label} value={s.value}></el-option>;
                    })}
                  </el-select>
                  &nbsp;&nbsp;后
                </el-form-item>
                <el-form-item class="split-time" key={`splitTime${i}`}>
                  <el-input-number value={v.splitTime} precision={0} controls={false} max={72} min={0} class="wid-50" onInput={val => (v.splitTime = val)} onBlur={this.onBlur.bind(this, v)}></el-input-number>
                  &nbsp;&nbsp;小时分账
                </el-form-item>
              </div>,
              <el-form-item key={`remark${i}`} label="备注">
                <el-input type="textarea" v-model={v.remark} maxlength={255} show-word-limit autosize={{ minRows: 4 }}></el-input>
                <div class="tip">1)此处仅支持微信支付连锁品牌分账方案,请提前申请;</div>
                <div class="tip">1)微信默认支持的最大分账比例为30%,如需高比例分账,需向微信支付申请;</div>
              </el-form-item>,
            ];
          })}
          <el-form-item>
            <div class="blockTitle">分销配置</div>
            <el-switch v-model={this.formData.isOpenCstPolicy} active-text={`开启顾客分销(默认分销策略: ${this.formData.cstPolicyName || '无'})`} />
            <br />
            <el-switch v-model={this.formData.isOpenGuiderPolicy} active-text={`开启导购分销(默认分销策略: ${this.formData.guiderPolicyName || '无'})`} />
            <br />
            <el-switch v-model={this.formData.isOpenSalespersonPolicy} active-text={`开启员工分销(默认分销策略: ${this.formData.salespersonPolicyName || '无'})`} />
          </el-form-item>
          <el-form-item>
            <div class="blockTitle">免审提现</div>
            <el-switch v-model={this.formData.isAutomaticProfitOut} active-text="开启" active-value={1} inactive-value={2}></el-switch>
            <div class="tip">
              <span class="redText">*&nbsp;</span>如开启免审提现功能，则本店分销员发起的提现申请，均无需审核，可在自动计算及扣除税金/手续费后，直接通过线上打款方式将佣金打至顾客微信钱包。
            </div>
          </el-form-item>
        </el-form>
      </div>
    );
  }
}
